// IMPORTANT: read first!
// Use https://transform.tools/ to transform copied SVG to JSX functional component and remove width and height and change fill to be current
// Video walk through https://www.loom.com/share/9fd4d60c4f2d49d08691c781842ac0ca

// rememeber to replace fill with currentColor!
// replace width and height with size prop

import * as React from "react";

export function SnackpassIcon(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 657 615"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M.082 246.918c0-21.761 17.622-39.401 39.36-39.401h3.874C51.71 91.872 148.096.661 265.762.661c52.649 0 101.038 18.262 139.19 48.802 14.357-4.042 29.292-6.117 44.49-6.117 90.574 0 164 73.502 164 164.171h3.28c21.738 0 39.36 17.64 39.36 39.401 0 118.844-63.646 226.363-164 284.416v24.226c0 32.64-26.433 59.101-59.04 59.101h-209.92c-32.607 0-59.04-26.461-59.04-59.101v-24.226C63.736 473.286.082 365.77.082 246.918zm182.385 249.54h291.229c87.578-51.275 143.026-145.462 143.026-249.54H39.442c0 104.084 55.454 198.27 143.025 249.54zm83.295-338.193c30.567 0 56.251 20.928 63.533 49.252h40.153c-7.873-50.231-51.297-88.653-103.686-88.653-52.389 0-95.813 38.422-103.686 88.653h40.152c7.283-28.324 32.967-49.252 63.534-49.252zm-143.399 49.252c8.142-72.059 69.238-128.054 143.399-128.054 74.16 0 135.256 55.995 143.398 128.054h39.56c-8.296-93.859-87.042-167.455-182.958-167.455-95.917 0-174.662 73.596-182.958 167.455h39.559zm412.359 0h39.36c0-68.909-55.803-124.77-124.64-124.77-3.534 0-7.046.146-10.53.438a223.54 223.54 0 0126.142 40.39c39.643 7.342 69.668 42.132 69.668 83.942zm-39.36 0a45.826 45.826 0 00-11.47-30.395 223.505 223.505 0 014.316 30.395h7.154zm-291.92 328.342v19.701c0 10.88 8.811 19.7 19.68 19.7h209.92c10.869 0 19.68-8.82 19.68-19.7v-19.701h-249.28z"
                fill="currentColor"
            />
        </svg>
    );
}

export function InboxIcon(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 52 48"
            fill={props.color}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.913 39.239c.592-.288 1.14-.467 1.643-.432C33.284 41.168 46 34.085 46 22.527 46 13.4 37.046 6 26 6S6 13.4 6 22.528c0 4.73 2.596 7.445 4.835 9.786 1.16 1.213 2.224 2.326 2.782 3.567l.052.12c.486 1.156.527 2.428-.2 3.997a9.11 9.11 0 01-.451.845c-.304.508-.037 1.186.554 1.156a6.07 6.07 0 001.104-.163c1.366-.327 2.607-1.072 3.723-1.742l.304-.182c.422-.252.826-.486 1.21-.673zm1.735 5.902c.196-.116.427-.161.653-.131 6.746.888 13.621-.62 19.068-4.044C47.412 37.167 52 30.751 52 22.528 52 9.066 39.238 0 26 0S0 9.066 0 22.528c0 7.208 4.16 11.514 6.4 13.832.146.151.284.294.412.429.327.343.574.615.761.828a.512.512 0 01.062.57 6.848 6.848 0 00-.152 5.886c1.002 2.24 3.363 4.075 6.398 3.918 2.873-.148 5.355-1.433 7.767-2.85z"
                fill={props.color}
            />
        </svg>
    );
}

export function InboxUnreadIcon(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 52 48"
            fill={props.color}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M46.261 19.787a.533.533 0 00-.427.604c.11.7.166 1.413.166 2.137 0 11.557-12.716 18.64-24.444 16.279-.504-.035-1.05.143-1.643.432-.384.187-.788.421-1.21.673l-.304.182c-1.116.67-2.357 1.415-3.723 1.742a6.07 6.07 0 01-1.104.163c-.59.03-.858-.648-.554-1.156a9.11 9.11 0 00.45-.845c.728-1.569.687-2.841.201-3.997a5.695 5.695 0 00-.052-.12c-.558-1.241-1.622-2.354-2.782-3.567C8.595 29.973 6 27.258 6 22.528 6 13.4 14.954 6 26 6c1.906 0 3.749.22 5.495.632a.53.53 0 00.64-.439 11.923 11.923 0 011.628-4.457c.18-.293.04-.683-.291-.77A29.527 29.527 0 0026 0C12.762 0 0 9.066 0 22.528c0 7.208 4.16 11.514 6.4 13.832.146.151.284.294.412.429.327.343.574.615.761.828a.512.512 0 01.062.57 6.848 6.848 0 00-.152 5.886c1.002 2.24 3.363 4.075 6.398 3.918 2.873-.148 5.355-1.433 7.767-2.85.196-.116.427-.161.653-.131 6.746.888 13.621-.62 19.068-4.044C47.412 37.167 52 30.751 52 22.528c0-1.494-.157-2.935-.455-4.314-.076-.352-.494-.496-.792-.293a11.934 11.934 0 01-4.492 1.866z"
                fill={props.color}
            />
            <path d="M36 8a8 8 0 1116 0 8 8 0 01-16 0z" fill="#FF3929" />
        </svg>
    );
}

export function ShareIcon(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 48 40"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.6169 0.263903C23.5397 0.748091 22.8469 1.81919 22.8469 3.00017V10.2031C19.4478 10.6249 16.0965 11.5973 13.0486 13.1687C9.81271 14.8372 6.51223 17.4077 4.03244 21.339C1.54733 25.2788 0 30.4058 0 37.0002C0 38.3993 0.967125 39.6126 2.331 39.9246C3.69488 40.2366 5.09334 39.5644 5.70163 38.3045C7.83284 33.8901 12.4096 31.7009 17.1056 30.6877C19.2577 30.2233 21.2905 30.0407 22.8469 29.9796V37.0002C22.8469 38.1812 23.5397 39.2523 24.6169 39.7364C25.694 40.2206 26.9551 40.0278 27.8383 39.2439L46.9915 22.2439C47.6329 21.6745 48 20.8579 48 20.0002C48 19.1425 47.6329 18.3258 46.9915 17.7565L27.8383 0.756491C26.9551 -0.027464 25.694 -0.220286 24.6169 0.263903Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function MyStoreIcon(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 144 136"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M135.369 48c4.384 0 7.601-4.12 6.538-8.373l-7.483-29.931c-.867-3.467-1.3-5.2-2.266-6.491a8.005 8.005 0 00-3.305-2.58C127.366 0 125.579 0 122.006 0H21.994c-3.573 0-5.36 0-6.846.625a8 8 0 00-3.306 2.58c-.966 1.29-1.4 3.024-2.266 6.49L2.093 39.628C1.03 43.88 4.247 48 8.631 48A3.37 3.37 0 0112 51.37V116a4 4 0 01-4 4 8 8 0 000 16h128a8 8 0 000-16 4 4 0 01-4-4V51.37c0-1.861 1.508-3.37 3.369-3.37zM76 107.2c0 4.48 0 6.721.872 8.432a8.002 8.002 0 003.496 3.496C82.08 120 84.32 120 88.8 120h14.4c4.48 0 6.721 0 8.432-.872a8.003 8.003 0 003.496-3.496c.872-1.711.872-3.952.872-8.432V76.8c0-4.48 0-6.72-.872-8.432a8.002 8.002 0 00-3.496-3.496C109.921 64 107.68 64 103.2 64H88.8c-4.48 0-6.72 0-8.432.872a8 8 0 00-3.496 3.496C76 70.08 76 72.32 76 76.8v30.4zm-16-24c0 4.48 0 6.72-.872 8.432a8 8 0 01-3.496 3.496C53.92 96 51.68 96 47.2 96h-6.4c-4.48 0-6.72 0-8.432-.872a8 8 0 01-3.496-3.496C28 89.92 28 87.68 28 83.2v-6.4c0-4.48 0-6.72.872-8.432a8 8 0 013.496-3.496C34.08 64 36.32 64 40.8 64h6.4c4.48 0 6.72 0 8.432.872a8 8 0 013.496 3.496C60 70.08 60 72.32 60 76.8v6.4z"
                fill="currentColor"
            />
        </svg>
    );
}

export function CompressIcon(props: any) {
    return (
        <svg
            width={props.size || "17"}
            height={props.size || "22"}
            viewBox="0 0 17 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M8.66666 0C9.21894 0 9.66666 0.447715 9.66666 1V4.58579L10.9595 3.29289C11.3501 2.90237 11.9832 2.90237 12.3738 3.29289C12.7643 3.68342 12.7643 4.31658 12.3738 4.70711L9.37376 7.70711C9.18623 7.89464 8.93187 8 8.66666 8C8.40144 8 8.14709 7.89464 7.95955 7.70711L4.95955 4.70711C4.56903 4.31658 4.56903 3.68342 4.95955 3.29289C5.35007 2.90237 5.98324 2.90237 6.37376 3.29289L7.66666 4.58579L7.66666 1C7.66666 0.447715 8.11437 0 8.66666 0Z"
                fill={props.color || "currentColor"}
            />
            <path
                d="M8.66666 22C9.21894 22 9.66666 21.5523 9.66666 21V17.4142L10.9595 18.7071C11.3501 19.0976 11.9832 19.0976 12.3738 18.7071C12.7643 18.3166 12.7643 17.6834 12.3738 17.2929L9.37376 14.2929C9.18623 14.1054 8.93187 14 8.66666 14C8.40144 14 8.14709 14.1054 7.95955 14.2929L4.95955 17.2929C4.56903 17.6834 4.56903 18.3166 4.95955 18.7071C5.35007 19.0976 5.98324 19.0976 6.37376 18.7071L7.66666 17.4142L7.66666 21C7.66666 21.5523 8.11437 22 8.66666 22Z"
                fill={props.color || "currentColor"}
            />
            <path
                d="M1.66666 10C1.11437 10 0.666656 10.4477 0.666656 11C0.666656 11.5523 1.11437 12 1.66666 12H15.6667C16.2189 12 16.6667 11.5523 16.6667 11C16.6667 10.4477 16.2189 10 15.6667 10H1.66666Z"
                fill={props.color || "currentColor"}
            />
        </svg>
    );
}

export function ExpandIcon(props: any) {
    return (
        <svg
            width={props.size || "17"}
            height={props.size || "22"}
            viewBox="0 0 17 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M0.333344 1C0.333344 0.447715 0.781059 0 1.33334 0H15.3333C15.8856 0 16.3333 0.447715 16.3333 1C16.3333 1.55228 15.8856 2 15.3333 2H1.33334C0.781059 2 0.333344 1.55228 0.333344 1Z"
                fill={props.color || "currentColor"}
            />
            <path
                d="M8.33334 4C8.59856 4 8.85291 4.10536 9.04045 4.29289L12.0405 7.29289C12.431 7.68342 12.431 8.31658 12.0405 8.70711C11.6499 9.09763 11.0168 9.09763 10.6262 8.70711L9.33334 7.41421V14.5858L10.6262 13.2929C11.0168 12.9024 11.6499 12.9024 12.0405 13.2929C12.431 13.6834 12.431 14.3166 12.0405 14.7071L9.04045 17.7071C8.85291 17.8946 8.59856 18 8.33334 18C8.06813 18 7.81377 17.8946 7.62624 17.7071L4.62624 14.7071C4.23571 14.3166 4.23571 13.6834 4.62624 13.2929C5.01676 12.9024 5.64993 12.9024 6.04045 13.2929L7.33334 14.5858L7.33334 7.41421L6.04045 8.70711C5.64993 9.09763 5.01676 9.09763 4.62624 8.70711C4.23571 8.31658 4.23571 7.68342 4.62624 7.29289L7.62624 4.29289C7.81377 4.10536 8.06813 4 8.33334 4Z"
                fill={props.color || "currentColor"}
            />
            <path
                d="M1.33334 20C0.781059 20 0.333344 20.4477 0.333344 21C0.333344 21.5523 0.781059 22 1.33334 22H15.3333C15.8856 22 16.3333 21.5523 16.3333 21C16.3333 20.4477 15.8856 20 15.3333 20H1.33334Z"
                fill={props.color || "currentColor"}
            />
        </svg>
    );
}

export function BlockIcon(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 18 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.58325 0.94502C8.84109 0.796159 9.15875 0.796159 9.41659 0.945019L16.6335 5.11169C16.8913 5.26055 17.0501 5.53565 17.0501 5.83337V14.1667C17.0501 14.4644 16.8913 14.7395 16.6335 14.8884L9.41659 19.0551C9.15875 19.2039 8.84109 19.2039 8.58325 19.0551L1.36637 14.8884C1.10854 14.7395 0.949707 14.4644 0.949707 14.1667V5.83337C0.949707 5.53565 1.10854 5.26055 1.36637 5.11169L8.58325 0.94502ZM8.99992 2.62896L3.44971 5.83337L8.99992 9.03779L14.5501 5.83337L8.99992 2.62896ZM15.3835 7.27675L9.83325 10.4812V16.89L15.3835 13.6856V7.27675ZM8.16659 16.89V10.4812L2.61637 7.27675V13.6856L8.16659 16.89Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function ColorSwatchIcon(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 19 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M5.83338 15.8334C6.75385 15.8334 7.50004 15.0872 7.50004 14.1667C7.50004 13.2462 6.75385 12.5 5.83338 12.5C4.9129 12.5 4.16671 13.2462 4.16671 14.1667C4.16671 15.0872 4.9129 15.8334 5.83338 15.8334Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.30126 0.833375C3.86198 0.83336 3.48299 0.833348 3.17085 0.858851C2.8414 0.885768 2.51372 0.945198 2.1984 1.10586C1.72799 1.34554 1.34554 1.72799 1.10586 2.1984C0.945198 2.51372 0.885768 2.8414 0.858851 3.17085C0.833348 3.48299 0.83336 3.86195 0.833375 4.30122V14.1667C0.833375 16.9281 3.07195 19.1667 5.83338 19.1667H15.6988C16.1381 19.1667 16.5171 19.1667 16.8292 19.1412C17.1587 19.1143 17.4864 19.0549 17.8017 18.8942C18.2721 18.6545 18.6545 18.2721 18.8942 17.8017C19.0549 17.4864 19.1143 17.1587 19.1412 16.8292C19.1667 16.5171 19.1667 16.1381 19.1667 15.6988V12.4734C19.1667 12.1078 19.1667 11.7924 19.1489 11.5314C19.1302 11.2565 19.0889 10.9816 18.9764 10.71C18.7227 10.0974 18.236 9.61075 17.6234 9.35701C17.566 9.33323 17.5085 9.31264 17.4508 9.29476C17.728 8.62956 17.7054 7.8738 17.3831 7.22334C17.199 6.85184 16.877 6.53068 16.5046 6.15928L13.8408 3.49548C13.4694 3.12312 13.1482 2.80111 12.7767 2.61702C12.1263 2.29469 11.3705 2.27211 10.7053 2.5493C10.6874 2.49163 10.6669 2.43407 10.6431 2.37667C10.3893 1.7641 9.90266 1.27741 9.29008 1.02368C9.01848 0.911174 8.74355 0.869921 8.46869 0.851168C8.20766 0.833357 7.89227 0.833365 7.52676 0.833375H4.30126ZM15.6667 17.5H9.91893L16.1928 10.834C16.4004 10.8352 16.5578 10.8384 16.6886 10.8473C16.8786 10.8603 16.9509 10.8824 16.9856 10.8968C17.1898 10.9814 17.352 11.1436 17.4366 11.3478C17.451 11.3825 17.4732 11.4548 17.4861 11.6448C17.4996 11.8423 17.5 12.1004 17.5 12.5V15.6667C17.5 16.1472 17.4994 16.4574 17.4801 16.6935C17.4616 16.9199 17.4302 17.0038 17.4092 17.045C17.3293 17.2018 17.2018 17.3293 17.045 17.4092C17.0038 17.4302 16.9199 17.4616 16.6935 17.4801C16.4574 17.4994 16.1472 17.5 15.6667 17.5ZM10.8334 14.0966L15.2252 9.43029C15.2314 9.42369 15.2377 9.41718 15.2441 9.41079C15.7461 8.90884 15.8443 8.79504 15.8897 8.70339C16.0052 8.47024 16.0052 8.19651 15.8897 7.96336C15.8443 7.87171 15.7461 7.75792 15.2441 7.25597L12.7441 4.75597C12.2422 4.25401 12.1284 4.1558 12.0367 4.11038C11.8036 3.99485 11.5298 3.99485 11.2967 4.11038C11.2223 4.14727 11.1332 4.219 10.8334 4.51363V14.0966ZM9.16671 14.1667V4.16421C9.16671 3.76595 9.16623 3.50858 9.15278 3.31151C9.13982 3.12151 9.11764 3.04915 9.10328 3.01447C9.0187 2.81028 8.85647 2.64805 8.65228 2.56348C8.6176 2.54911 8.54524 2.52693 8.35524 2.51397C8.15776 2.50049 7.89973 2.50004 7.50004 2.50004H4.33338C3.85292 2.50004 3.54269 2.50069 3.30657 2.51998C3.08019 2.53848 2.99625 2.56988 2.95505 2.59087C2.79825 2.67077 2.67077 2.79825 2.59087 2.95505C2.56988 2.99625 2.53848 3.08019 2.51998 3.30657C2.50069 3.54269 2.50004 3.85292 2.50004 4.33338V14.1667C2.50004 16.0077 3.99243 17.5 5.83338 17.5C7.67433 17.5 9.16671 16.0077 9.16671 14.1667Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function MediaIcon(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 20 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.00004 0.833374H6.96437C6.06122 0.833366 5.33275 0.83336 4.74286 0.881556C4.13548 0.931181 3.60199 1.03602 3.10841 1.28751C2.32441 1.68699 1.68699 2.32441 1.28751 3.10841C1.03602 3.60199 0.931181 4.13548 0.881556 4.74286C0.83336 5.33275 0.833366 6.06121 0.833374 6.96437V7.00004V15C0.833374 17.3012 2.69886 19.1667 5.00004 19.1667H14.1667L14.2632 19.1667C14.9445 19.1669 15.4089 19.167 15.8129 19.0866C17.4658 18.7579 18.7579 17.4658 19.0866 15.8129C19.167 15.4089 19.1669 14.9445 19.1667 14.2632L19.1667 14.1667V7.00004V6.96435C19.1667 6.06124 19.1667 5.33273 19.1185 4.74285C19.0689 4.13548 18.9641 3.60199 18.7126 3.10841C18.3131 2.32441 17.6757 1.68699 16.8917 1.28751C16.3981 1.03602 15.8646 0.931181 15.2572 0.881556C14.6673 0.833359 13.9389 0.833366 13.0357 0.833374H13H7.00004ZM3.86507 2.77253C4.08453 2.6607 4.37427 2.58389 4.87857 2.54269C5.39261 2.50069 6.05287 2.50004 7.00004 2.50004H13C13.9472 2.50004 14.6075 2.50069 15.1215 2.54269C15.6258 2.58389 15.9156 2.6607 16.135 2.77253C16.6054 3.01221 16.9879 3.39466 17.2276 3.86507C17.3394 4.08453 17.4162 4.37427 17.4574 4.87857C17.4994 5.39261 17.5 6.05287 17.5 7.00004V12.1549L13.9226 8.57745C13.5972 8.25202 13.0696 8.25202 12.7441 8.57745L9.16671 12.1549L7.25596 10.2441C6.9512 9.93935 6.46433 9.91727 6.13322 10.1932L2.50004 13.2208V7.00004C2.50004 6.05287 2.50069 5.39261 2.54269 4.87857C2.58389 4.37427 2.6607 4.08453 2.77253 3.86507C3.01221 3.39466 3.39466 3.01221 3.86507 2.77253ZM13.3334 10.3452L17.4996 14.5115C17.4978 15.0687 17.4891 15.3011 17.452 15.4878C17.2547 16.4795 16.4795 17.2547 15.4878 17.452C15.2666 17.496 14.9811 17.5 14.1667 17.5H5.00004C3.74432 17.5 2.70483 16.5742 2.52692 15.368L6.61557 11.9607L8.57745 13.9226C8.90289 14.2481 9.43053 14.2481 9.75596 13.9226L13.3334 10.3452ZM5.83337 7.50004C6.75385 7.50004 7.50004 6.75385 7.50004 5.83337C7.50004 4.9129 6.75385 4.16671 5.83337 4.16671C4.9129 4.16671 4.16671 4.9129 4.16671 5.83337C4.16671 6.75385 4.9129 7.50004 5.83337 7.50004Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function CartIcon(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 20 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.16667 0C4.73703 0 5.23159 0.385385 5.3753 0.931L5.39203 1.00306L6.02917 4.16667H18.75C19.515 4.16667 20.0944 4.84539 19.9878 5.59159L19.9753 5.66399L18.5693 12.6291C18.3138 13.9703 17.1641 14.95 15.8088 14.9981L15.7042 15H8.04988C6.68142 15 5.50217 14.0497 5.20732 12.739L3.14333 2.5H1.25C0.5843 2.5 0.0401413 1.97962 0.00212196 1.32345L0 1.25C0 0.5843 0.520383 0.0401413 1.17655 0.00212196L1.25 0H4.16667ZM17.2221 6.66667H6.53292L7.64035 12.1601C7.67422 12.3408 7.82163 12.4758 8.00041 12.4971L8.04988 12.5H15.7042C15.8875 12.5 16.0472 12.3805 16.1034 12.1989L16.1161 12.1479L17.2221 6.66667Z"
                fill="currentColor"
            />
            <path
                d="M7.91667 20C8.83714 20 9.58333 19.2538 9.58333 18.3333C9.58333 17.4129 8.83714 16.6667 7.91667 16.6667C6.99619 16.6667 6.25 17.4129 6.25 18.3333C6.25 19.2538 6.99619 20 7.91667 20Z"
                fill="currentColor"
            />
            <path
                d="M16.25 20C17.1705 20 17.9167 19.2538 17.9167 18.3333C17.9167 17.4129 17.1705 16.6667 16.25 16.6667C15.3295 16.6667 14.5833 17.4129 14.5833 18.3333C14.5833 19.2538 15.3295 20 16.25 20Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function ChatIcon(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 22 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.46395 16.3495C8.71047 16.2294 8.93854 16.1551 9.14815 16.1696C14.035 17.1534 19.3333 14.202 19.3333 9.38657C19.3333 5.58322 15.6024 2.5 11 2.5C6.39763 2.5 2.66667 5.58322 2.66667 9.38657C2.66667 11.3576 3.74821 12.4886 4.68115 13.4642C5.16449 13.9696 5.60795 14.4333 5.84045 14.9506C5.8479 14.9671 5.85512 14.9837 5.86213 15.0004C6.06452 15.4821 6.08177 16.0121 5.77851 16.6659C5.72584 16.7794 5.66351 16.8967 5.5908 17.0181C5.46419 17.2295 5.57546 17.5123 5.82151 17.4996C5.97846 17.4915 6.13179 17.4676 6.28151 17.4318C6.85087 17.2953 7.36798 16.9849 7.83282 16.7058C7.8755 16.6802 7.91773 16.6549 7.95952 16.63C8.13547 16.525 8.30361 16.4276 8.46395 16.3495ZM9.1865 18.8087C9.2685 18.7605 9.36443 18.7416 9.45873 18.754C12.2697 19.1241 15.1342 18.4962 17.4039 17.0693C19.9216 15.4864 21.8333 12.8128 21.8333 9.38657C21.8333 3.77757 16.5158 0 11 0C5.48417 0 0.166672 3.77757 0.166672 9.38657C0.166672 12.3899 1.89984 14.184 2.83311 15.1501C2.89399 15.2131 2.95147 15.2726 3.00484 15.3287C3.14106 15.4718 3.24426 15.5852 3.32212 15.6739C3.37965 15.7394 3.38721 15.8338 3.34782 15.9116C2.96268 16.672 2.93116 17.5744 3.28441 18.3639C3.70196 19.2971 4.68589 20.0615 5.9503 19.9963C7.14754 19.9345 8.18159 19.3993 9.1865 18.8087Z"
                fill="currentColor"
            />
        </svg>
    );
}

//Used for links that does want an icon attached
export function EmptyIcon(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        ></svg>
    );
}

export function SnackpassLogoSquare(props: any) {
    return (
        <svg
            width={props.size || "1em"}
            height={props.size || "1em"}
            viewBox="0 0 144 144"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.815 19.11C0 26.597 0 36.398 0 56v32c0 19.602 0 29.403 3.815 36.89a35 35 0 0015.295 15.295C26.597 144 36.398 144 56 144h32c19.602 0 29.403 0 36.89-3.815a34.999 34.999 0 0015.295-15.295C144 117.403 144 107.602 144 88V56c0-19.602 0-29.403-3.815-36.89A35 35 0 00124.89 3.815C117.403 0 107.602 0 88 0H56C36.398 0 26.597 0 19.11 3.815A35 35 0 003.815 19.11zM29.76 56.993c-3.181 0-5.76 2.644-5.76 5.904 0 17.809 9.315 33.919 24 42.616v3.63c0 4.891 3.868 8.856 8.64 8.856h30.72c4.772 0 8.64-3.965 8.64-8.856v-3.63c14.686-8.698 24-24.809 24-42.616 0-3.26-2.579-5.904-5.76-5.904h-.48c0-13.585-10.745-24.599-24-24.599-2.224 0-4.41.311-6.51.917C77.665 28.735 70.584 26 62.88 26c-17.22 0-31.325 13.667-32.553 30.994h-.567zm63.55 43.295H50.69c-12.815-7.683-20.93-21.795-20.93-37.39h84.48c0 15.594-8.114 29.707-20.93 37.39zM72.176 56.993c-1.065-4.244-4.824-7.38-9.297-7.38-4.474 0-8.232 3.136-9.298 7.38h-5.876c1.152-7.526 7.507-13.283 15.174-13.283 7.666 0 14.021 5.757 15.173 13.283h-5.876zM62.88 37.806c-10.853 0-19.794 8.39-20.985 19.187h-5.79c1.215-14.063 12.738-25.09 26.775-25.09 14.036 0 25.56 11.027 26.774 25.09h-5.79c-1.19-10.797-10.132-19.187-20.984-19.187zM108 56.993h-5.76c0-6.264-4.394-11.477-10.195-12.577a33.596 33.596 0 00-3.826-6.052c.51-.044 1.024-.066 1.54-.066 10.074 0 18.241 8.37 18.241 18.695zM94.801 52.44a6.96 6.96 0 011.679 4.554h-1.047c-.11-1.55-.323-3.07-.632-4.554zM53.76 109.143v-2.952h36.48v2.952c0 1.63-1.29 2.952-2.88 2.952H56.64c-1.59 0-2.88-1.322-2.88-2.952z"
                fill="currentColor"
            />
        </svg>
    );
}
